import React from 'react';
import {
  getBrandingDisplayName,
  getBrandingLogoMode,
  getBrandingLogoUrl,
} from '../../api/pmcExperienceService';

interface PmcCoBrandProps {
  imgClassName?: string;
  pmcMaxWidth?: string;
  /** Height class for the (smaller) GetPawtected secondary mark in co-brand. */
  gpClassName?: string;
}

/**
 * PMC logo/name lockup. With a PMC logo and logoMode 'replace' it shows the PMC
 * logo only; otherwise (co-brand, default) it shows PMC × GetPawtected with
 * GetPawtected as a SMALLER secondary mark. min-w-0 + shrink so it never
 * overflows its container. Falls back to the platform logo when no PMC brand.
 */
const PmcCoBrand: React.FC<PmcCoBrandProps> = ({
  imgClassName = 'h-8 w-auto',
  pmcMaxWidth = 'max-w-[110px]',
  gpClassName = 'h-5 w-auto',
}) => {
  const logoUrl = getBrandingLogoUrl();
  const displayName = getBrandingDisplayName();
  const hasPmc = Boolean(logoUrl || displayName);
  const showGp = !(getBrandingLogoMode() === 'replace' && hasPmc);

  return (
    <div className="flex min-w-0 items-center gap-1.5 overflow-hidden">
      {logoUrl && (
        <img
          src={logoUrl}
          alt={displayName || 'PMC'}
          className={`${imgClassName} ${pmcMaxWidth} shrink-0 object-contain`}
        />
      )}
      {!logoUrl && displayName && (
        <span className="truncate text-sm font-semibold text-gray-800">{displayName}</span>
      )}
      {hasPmc && showGp && (
        <span className="shrink-0 select-none text-sm font-light text-gray-300">×</span>
      )}
      {showGp && (
        <img
          src="/landing/getpawtected.svg"
          alt="GetPawtected"
          className={`${hasPmc ? gpClassName : imgClassName} ${hasPmc ? 'max-w-[80px] opacity-90' : 'max-w-[140px]'} shrink-0 object-contain`}
        />
      )}
    </div>
  );
};

export default PmcCoBrand;
